import { useIntl } from 'react-intl'
import { Button } from 'primereact/button'
import { OperatingRoomGridState } from '../useOperatingRoomGrid'

interface OperatingRoomGridNoticeProps {
  state: OperatingRoomGridState
  /** Qué no se pudo consultar («No se pudo consultar la lista. Intentá de nuevo.»). */
  errorMessageId: string
  onRetry: () => void
}

/**
 * Lo que pasó con la última consulta de una grilla, cuando no fue bien: un error con «Reintentar» (nunca una grilla vacía
 * que parezca «sin datos») o el «sin permiso» con qué hacer. Sin problema no muestra nada.
 */
export default function OperatingRoomGridNotice({ state, errorMessageId, onRetry }: OperatingRoomGridNoticeProps) {
  const intl = useIntl()
  if (state === 'ok') return null
  if (state === 'denied' || state === 'surgeonDenied') {
    return (
      <p className="nv-note" role="status">
        <i className="pi pi-info-circle" aria-hidden="true" />
        {intl.formatMessage({ id: state === 'denied' ? 'OperatingRoomIndicatorsAccessDenied' : 'OperatingRoomIndicatorsSurgeonDenied' })}
      </p>
    )
  }
  return (
    <div className="nv-card nv-or-error" role="alert">
      <p className="nv-note">
        <i className="pi pi-info-circle" aria-hidden="true" />
        {intl.formatMessage({ id: errorMessageId })}
      </p>
      <Button type="button" className="buttonMain2" outlined label={intl.formatMessage({ id: 'OperatingRoomIndicatorsRetry' })} onClick={onRetry} />
    </div>
  )
}
